import React, { useEffect } from 'react';
import useUserStore from '../../store/userStore';
import useSchoolStore from '../../store/schoolStore';
import UserInput from './UserInput';
import LoadingMessage from '../common/LoadingMessage';

const LoginForm = () => {
  const {
    isLoading: schoolLoading,
    schoolId,
    setSchoolData,
  } = useSchoolStore();

  const {
    isLoading: userLoading,
  } = useUserStore();

  // Combined loading state
  const isLoading = schoolLoading || userLoading;

  // Load school data when component mounts if not loaded yet
  useEffect(() => {
    if (schoolId) {
      setSchoolData(schoolId);
    }
  }, [schoolId, setSchoolData]);

  if (schoolLoading) {
    return (
      <LoadingMessage message="Loading your school…" size="medium" />
    );
  }

  return (
    <div className="w-full">
      <UserInput />
    </div>
  );
};

export default LoginForm;